import React, { useEffect, useState } from "react";
import styled from "styled-components";

import { ReactComponent as CloseIcon } from "../../Assets/iconsv2/generic/closeBtn.svg";
import { ReactComponent as ChainLink } from "../../Assets/icons/context-menu-icons/chainLink.svg";
import { ReactComponent as ShareIcon } from "../../Assets/icons/context-menu-icons/share.svg";
import { CircularProgressBar } from "../GenericComponents/CircularProgressBar";
import { useAuthService } from "../../Context/AuthContext";
import copy from "copy-to-clipboard";

import { useLinksquaredService } from "../../Context/LinksquaredContext";
import { useTranslate } from '@tolgee/react';
import { useNotify } from "../../Helpers/Notifications";

const RefferalModal = ({ handleClose, setLoading }) => {
  const { generateLink } = useLinksquaredService();
  const { notifySuccess, notifyError, notifyInfo } = useNotify();
  const { t } = useTranslate();
  const { user, referrals, getNumberOfReferrals } = useAuthService();

  const [inviteLink, setInviteLink] = useState("");

  const handleShare = () => {
    let title = t('refferal_modal.title');
    let message = `${user.name} ${t('refferal_modal.invited_you')}`;
    copy(`${title}\n${message}\n${inviteLink} `);
    notifySuccess(t('refferal_modal.copied'));
  };

  useEffect(() => {
    const keyDownHandler = (event) => {
      if (event.key === "Escape") {
        event.preventDefault();
        // 👇️ your logic here
        handleClose();
      }
    };

    document.addEventListener("keydown", keyDownHandler);

    return () => {
      document.removeEventListener("keydown", keyDownHandler);
    };
  }, []);

  const handleCreateLink = () => {
    setLoading(true);
    generateLink(
      t('refferal_modal.title'),
      t('refferal_modal.you_are_invited'),
      user,
      (successData) => {
        setLoading(false);
        setInviteLink(successData);
      },
      (errorData) => {
        setLoading(false);
        console.error("Error creating link:", errorData);
      }
    );
  };

  const handleGetReferrals = () => {
    setLoading(true);
    getNumberOfReferrals(
      (response) => {
        setLoading(false);
      },
      (error) => {
        setLoading(false);
        console.log(error);
      }
    );
  };

  useEffect(() => {
    handleGetReferrals();
    handleCreateLink();
  }, []);

  return (
    <FullScreenItem>
      <Card>
        <Line>
          <Title>{t('refferal_modal.refferal')}</Title>
          <CloseBtn onClick={handleClose}>
            <CloseIcon />
          </CloseBtn>
        </Line>

        <Line style={{ justifyContent: "center" }}>
          {referrals > 4 ? (
            <InfoText>
              {t('refferal_modal.congrats')}<br />
              <InfoTextSpan>
                {" " +t('refferal_modal.moth_free')}
              </InfoTextSpan>
            </InfoText>
          ) : (
            <InfoText>
              {" " +t('refferal_modal.invite5')} <br />
              <InfoTextSpan>
                {" " +t('refferal_modal.moth_free')}
              </InfoTextSpan>
            </InfoText>
          )}
        </Line>

        <Line style={{ justifyContent: "center" }}>
          <CircularProgressBar
            key={"sdqweqw1"}
            value={referrals}
            maxValue={5}
            size={200}
            strokeWidth={10}
          />
        </Line>

        <Line style={{ flexDirection: "column", gap: "10px" }}>
          <InfoText> {t('refferal_modal.referral_link')}</InfoText>
          <CustomInviteInputWrapper>
            <ChainLink />
            <CustomInput
              value={inviteLink}
              readOnly
              onClick={() => handleShare()}
            />
            <InvisibleBtn onClick={() => handleShare()}>
              <ShareIcon />
            </InvisibleBtn>
          </CustomInviteInputWrapper>
        </Line>
      </Card>
    </FullScreenItem>
  );
};

export default RefferalModal;

const FullScreenItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  left: 0;
  top: 0;
  z-index: 2;
`;
const Card = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 200px;
  max-width: 500px;
  width: 100%;
 background:${({ theme }) => theme.menu.background};
  border-radius: 4px;
  padding: 25px;
  position: relative;
  gap: 30px;
`;
const Line = styled.div`
  display: flex;
  width: 100%;
  gap: 20px;
  align-items: center;
`;

const Title = styled.h1`
  font-size: 20px;
  font-weight: 500;
  line-height: 24px;
  color: ${({ theme }) => theme.menu.primaryTextColor};
`;

const CloseBtn = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: none;
  cursor: pointer;
  margin-left: auto;
  max-width: 32px;
  svg{
  height:26px;
  width:26px;
  color:${({ theme }) => theme.menu.selectedOpionBackground};
  stroke:${({ theme }) => theme.sidebar.borderColor};
  }
`;
const InfoText = styled.p`
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  color: ${({ theme }) => theme.menu.secondaryTextColor};
`;
const InfoTextSpan = styled.span`
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  text-align: center;
  color: ${({ theme }) => theme.premium_green};

`;
const CustomInviteInputWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  border-radius: 4px;
 background:${({ theme }) => theme.menu.enterPhoneNumberBackground};
  width: 100%;
  padding: 15px 20px;
`;
const CustomInput = styled.input`
  width: 100%;
  background: none;
  font-size: 18px;
  line-height: 24px;
  border: none;
  outline: none;
  color: ${({ theme }) => theme.menu.secondaryTextColor};
`;
const InvisibleBtn = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background: none;
  border: none;
color:${({ theme }) => theme.menu.selectedTextColor};
svg{
height:20px;


}
`;
